<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">{{ list ? list.list_name : 'ユニークキーリスト' }}</div>
        </div>
        <a class="c-btn c-btn--blue u-w300" :href="'/coins-admin/unique-key-message/add?list_id=' + listId">
          <p class="c-btn__text">このリストで配信を作成</p>
        </a>
      </div>
      <div class="l-main-content">
        <div v-if="!list" class="c-loader c-loader"></div>
        <div v-else class="unique-key-review">
          <dl class="unique-key-review__summary">
            <div class="unique-key-review__row">
              <dt>キー数</dt>
              <dd class="unique-key-review__num">{{ list.key_count.toLocaleString() }}</dd>
            </div>
            <div class="unique-key-review__row">
              <dt>端末と一致したキー</dt>
              <dd class="unique-key-review__num">
                <span v-if="reach">{{ reach.matched_key_count.toLocaleString() }}</span>
                <span v-else class="unique-key-review__pending">{{ reachStatusText }}</span>
                <span class="unique-key-review__note">（現時点）</span>
              </dd>
            </div>
            <div class="unique-key-review__row">
              <dt>配信対象数</dt>
              <dd class="unique-key-review__num">
                <span v-if="reach">{{ reach.reach_count.toLocaleString() }} 件</span>
                <span v-else class="unique-key-review__pending">{{ reachStatusText }}</span>
                <span class="unique-key-review__note">（現時点・有効な端末のみ）</span>
              </dd>
            </div>
            <div class="unique-key-review__row">
              <dt>登録日時</dt>
              <dd>{{ getDisplayDateTime(list.create_date) }}</dd>
            </div>
            <div class="unique-key-review__row">
              <dt>元ファイル名</dt>
              <dd>{{ list.original_file_name || '-' }}</dd>
            </div>
          </dl>
          <p class="unique-key-review__explain">
            1つのキーが複数の端末と紐付いている場合、配信対象数はキーの数より多くなります。
            1つの端末にリスト内の複数のキーが紐付いている場合、その端末にはキーの数だけ送られ、配信対象数もその数で数えます。
            端末の紐付けは日々変わるため、実際の配信数は配信時点の値になります。
          </p>

          <div class="unique-key-review__actions">
            <a class="c-btn c-btn--gray u-w200 u-h50" href="/coins-admin/unique-key-list">
              <p class="c-btn__text">一覧に戻る</p>
            </a>
            <button type="button" class="c-btn c-btn--red u-w200 u-h50" @click="isDeleting = true">
              <p class="c-btn__text">削除する</p>
            </button>
          </div>
        </div>
      </div>
    </main>

    <control-modal
      ref="refDeleteModal"
      classes="c-modal--message-delete"
      title="このリストを削除してもよろしいですか?"
      :body="list ? `リスト : ${list.list_name}（下書き・配信待ちの配信に使われている間は削除できません）` : ''"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active="isDeleting"
      :on-close-click="onCloseDeleteModal"
      :on-cancel-click="onCloseDeleteModal"
      :on-enter-click="onEnterDeleteModal"
    />

    <error-modal :is-active="errorMessage !== ''" :message="errorMessage" :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    csrfToken: String,
    listId: Number,
  },
  data() {
    return {
      list: null,
      reach: null,
      reachFailed: false,
      isDeleting: false,
      errorMessage: '',
    };
  },
  computed: {
    reachStatusText: function () {
      return this.reachFailed ? '取得できませんでした。時間をおいて開き直してください' : '確認しています…';
    },
  },
  mounted: function () {
    this.loadList();
    this.loadReachCount();
  },
  methods: {
    loadList: function () {
      axios
        .get('/api/unique-key-list/get', { params: { list_id: this.listId } })
        .then((res) => {
          this.list = res.data.list;
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.errorMessage = 'リストの取得に失敗しました。再度お試しください。';
        });
    },
    // 件数は RDS で数えるため時間がかかることがあり、リストの表示とは別に取る
    loadReachCount: function () {
      axios
        .get('/api/unique-key-list/reach-count', { params: { list_id: this.listId }, timeout: 65000 })
        .then((res) => {
          this.reach = res.data;
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.reachFailed = true;
        });
    },
    onCloseDeleteModal: function () {
      this.isDeleting = false;
      this.$refs.refDeleteModal.resetErrorMessage();
    },
    onEnterDeleteModal: function () {
      this.$refs.refDeleteModal.showLoader();
      axios
        .post('/api/unique-key-list/delete', { list_id: this.listId })
        .then((res) => {
          if (!this.handleResponse(res, false)) {
            this.$refs.refDeleteModal.hideLoader();
            this.$refs.refDeleteModal.showErrorMessage(res.data.message);
            return;
          }
          location.href = '/coins-admin/unique-key-list';
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.$refs.refDeleteModal.hideLoader();
          this.$refs.refDeleteModal.showErrorMessage('削除に失敗しました。再度お試しください。');
        });
    },
    onCloseErrorModal: function () {
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped>
.unique-key-review {
  display: grid;
  gap: 24px;
  max-width: 760px;
}
.unique-key-review__summary {
  display: grid;
  gap: 1px;
  background: #dde3e8;
  border: 1px solid #dde3e8;
}
.unique-key-review__row {
  display: grid;
  grid-template-columns: 200px 1fr;
  background: #fff;
}
.unique-key-review__row dt {
  background: #f5f7f9;
  font-weight: bold;
  padding: 12px 16px;
}
.unique-key-review__row dd {
  padding: 12px 16px;
}
.unique-key-review__num {
  font-variant-numeric: tabular-nums;
}
.unique-key-review__pending,
.unique-key-review__note,
.unique-key-review__explain {
  color: #666;
  font-size: 13px;
}
.unique-key-review__actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  /* フッター直前で終わらないよう、右下のページトップボタンと重ならない分を空ける (配信詳細と同じ) */
  margin-bottom: 80px;
}
</style>
